import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // Initialize i18n
import App from "@/App";
import { initSentry, SentryErrorBoundary } from "@/utils/sentry";

// ============================================================================
// SENTRY INITIALIZATION (MUST BE FIRST)
// ============================================================================
initSentry();

// ============================================================================
// APP VERSION CACHE CONTROL
// ============================================================================
// Clear corrupted cache when app version changes
// This prevents stale data issues after deployments
const APP_VERSION = '1.0.0';

const storedVersion = localStorage.getItem('app_version');

if (storedVersion !== APP_VERSION) {
  console.warn('🔄 App version changed:', storedVersion, '->', APP_VERSION);
  console.warn('🧹 Clearing corrupted cache...');
  localStorage.clear();
  sessionStorage.clear();
  localStorage.setItem('app_version', APP_VERSION);
  console.log('✅ Cache cleared, new version set');
}

// ============================================================================

const root = ReactDOM.createRoot(document.getElementById("root"));

// CRITICAL: StrictMode removed to prevent double-mount issues
// StrictMode causes components to mount/unmount/remount in development
// This was causing infinite loading loops with Supabase calls
root.render(
  <SentryErrorBoundary fallback={<SentryErrorFallback />}>
    <App />
  </SentryErrorBoundary>
);

// Fallback component for top-level errors
function SentryErrorFallback({ error, resetError }) {
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6">
      <div className="max-w-md text-center">
        <div className="w-20 h-20 bg-red-500/10 border-2 border-red-500/30 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl">⚠️</span>
        </div>
        <h1 className="text-2xl font-light text-white mb-3">
          Si è verificato un errore
        </h1>
        <p className="text-zinc-400 mb-6">
          Ci scusiamo per l'inconveniente. Il nostro team è stato notificato automaticamente.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-6 py-3 bg-gradient-to-r from-[#B08B5C] to-[#C8A36A] text-black font-medium rounded-lg hover:brightness-110"
        >
          Ricarica Pagina
        </button>
        {process.env.NODE_ENV === 'development' && (
          <details className="mt-6 text-left bg-zinc-900 rounded-lg p-4 text-xs text-red-400">
            <summary className="cursor-pointer text-zinc-500 mb-2">Error Details</summary>
            <pre className="whitespace-pre-wrap">{error?.toString()}</pre>
          </details>
        )}
      </div>
    </div>
  );
}
